import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Plus } from '@/icons';

interface FamiliesEmptyHeroProps {
  allowed: boolean;
  onCreate: () => void;
}

const FamiliesEmptyHero: React.FC<FamiliesEmptyHeroProps> = ({ allowed, onCreate }) => {
  const { t } = useTranslation('screens');

  return (
    <div className="empty-hero">
      <span className="empty-hero__stripe" aria-hidden />
      <h2 className="empty-hero__title">
        <Trans i18nKey="familiesEmptyHero.title" ns="screens" components={{ em: <em /> }} />
      </h2>
      <p className="empty-hero__body">{t('familiesEmptyHero.body')}</p>
      <button
        type="button"
        className="btn btn--primary btn--lg"
        onClick={onCreate}
        disabled={!allowed}
        title={allowed ? t('familiesEmptyHero.createTitleAllowed') : t('familiesEmptyHero.createTitleRestricted')}
      >
        <Plus width={16} height={16} />
        {t('familiesEmptyHero.createButton')}
      </button>
    </div>
  );
};

export default FamiliesEmptyHero;
